import React, { useState, useEffect } from "react"
import { useCookies } from 'react-cookie';
import Sidebar from './SideBar';
import useAuthRedirect from "./Componentes/auth";
import Axios from 'axios';
import Swal from 'sweetalert2';
import config from './Componentes/config';
import moment from 'moment';
import { registrarLog } from './Componentes/logService';
import { generarOrdenCompraPDF } from './Documentos/OrdenCompraPDF';
import FirmaDigital from './Componentes/FirmaDigital';
import { getEmpresaByCodigo } from './Componentes/empresasConfig';

const cardImages = {
    DAFA: "/img/dafaLogo.png",
    FUGA: "/img/fugarLogo.png",
    INVE: "/img/idafaLogo.png",
    TRAN: "/img/extasisLogo.png",
    NIDI: "/img/nidiamLogo.png"
};

function Administracion() {
    useAuthRedirect();
    const [cookies] = useCookies(['selectedCard', 'usuario', 'idEmpresa']);
    const imageUrl = cardImages[cookies.selectedCard]
    const [isComponentsCollapsed, setIsComponentsCollapsed] = useState(true);
    const [isUtilitiesCollapsed, setIsUtilitiesCollapsed] = useState(true);
    const [isInventario, setisIventatioCollapsed] = useState(true);
    const [isPrevencion, setisPrevencionCollapsed] = useState(true);
    const [isLogistica, setisLogisticaCollapsed] = useState(true);
    const [isContabilidadCollapsed, setIsContabilidadCollapsed] = useState(true);
    const [isAdministracionCollapsed, setIsAdministracionCollapsed] = useState(true);

    const toggleCollapse = (collapseSetter) => {
        collapseSetter(prevState => !prevState);
    };

    const getEmpresaName = (card) => getEmpresaByCodigo(card).nombre;

    // Empresa activa: la cookie la fija Prehome al seleccionar la tarjeta; el config es respaldo.
    const idEmpresa = cookies.idEmpresa || getEmpresaByCodigo(cookies.selectedCard).idEmpresa;

    // Estados
    const empresa = getEmpresaName(cookies.selectedCard);
    const [listadoVacaciones, setlistadoVacaciones] = useState([]);
    const [listadoSolicitudesAprobacion, setListadoSolicitudesAprobacion] = useState([]);
    const [ordenDetalles, setOrdenDetalles] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [mostrarFirmaDigital, setMostrarFirmaDigital] = useState(false);

    // Estados para historial
    const [historialVacaciones, setHistorialVacaciones] = useState([]);
    const [historialOrdenes, setHistorialOrdenes] = useState([]);
    const [modalHistorialVacaciones, setModalHistorialVacaciones] = useState(false);
    const [modalHistorialOrdenes, setModalHistorialOrdenes] = useState(false);

    // Estados para paginación y filtros de vacaciones
    const [currentPageVacaciones, setCurrentPageVacaciones] = useState(1);
    const [itemsPerPageVacaciones, setItemsPerPageVacaciones] = useState(10);
    const [sortFieldVacaciones, setSortFieldVacaciones] = useState('Fecha_Solicitud');
    const [sortDirectionVacaciones, setSortDirectionVacaciones] = useState('desc');
    const [filteredHistorialVacaciones, setFilteredHistorialVacaciones] = useState([]);

    // Estados para paginación y filtros de órdenes
    const [currentPageOrdenes, setCurrentPageOrdenes] = useState(1);
    const [itemsPerPageOrdenes, setItemsPerPageOrdenes] = useState(10);
    const [sortFieldOrdenes, setSortFieldOrdenes] = useState('Fecha_Solicitud');
    const [sortDirectionOrdenes, setSortDirectionOrdenes] = useState('desc');
    const [filteredHistorialOrdenes, setFilteredHistorialOrdenes] = useState([]);

    const getSolicitudesVacaciones = () => {
        console.log("intentando cargar solicitudes de vacaciones panel adm");
        if (!idEmpresa) {
            setlistadoVacaciones([]);
            return;
        }
        Axios.get(`${config.API_URL}/cargaSolicitudesVacaciones`, {
            params: { idEmpresa }
        })
            .then(res => {
                console.log(res.data);
                if (Array.isArray(res.data)) {
                    setlistadoVacaciones(res.data);
                    console.log(res.data);
                } else {
                    console.error('La respuesta no es un array:', res.data);
                    setlistadoVacaciones([]);
                }
            })
            .catch(err => {
                console.error("Error al obtener los datos:", err);
            });
    }

    const EstadoVacaciones = async (estado, NombreTrabajador, id) => {
        // Validar firma antes de aprobar
        if (estado === 'Aprobado') {
            const firmaGuardada = localStorage.getItem('firmaAdministrador');
            if (!firmaGuardada) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Firma requerida',
                    text: 'Debe configurar su firma digital antes de aprobar solicitudes.',
                    confirmButtonColor: '#3085d6',
                });
                setMostrarFirmaDigital(true);
                return;
            }
        }

        const datos = {
            Estado: estado,
            Aprueba: cookies.usuario,
            id: id
        };

        try {
            const response = await Axios.put(`${config.API_URL}/EstadoVacaciones`, datos, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Administracion',
                Detalle: `Cambio estado vacaciones trabajador: ${NombreTrabajador} - Estado: ${estado}`,
                Estado: 'Éxito',
            });

            Swal.fire(
                '¡Éxito!',
                `La solicitud se ${estado === 'Aprobado' ? 'aprobo' : 'rechazo'} exitosamente`,
                'success'
            );

            getSolicitudesVacaciones();
        } catch (error) {
            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Administracion',
                Detalle: `Error al intentar el estado: ${estado}  del trabajador: ${NombreTrabajador} - Error: ${error.message || error}`,
                Estado: 'Fallo',
            });

            Swal.fire(
                '¡Algo pasó!',
                'Hubo un error al enviar la petición.',
                'error'
            );
        }
    };

    // Función para cargar solicitudes de aprobación pendientes
    const getSolicitudesAprobacion = () => {
        console.log("intentando cargar solicitudes de aprobación panel adm");
        if (!idEmpresa) {
            setListadoSolicitudesAprobacion([]);
            return;
        }
        Axios.get(`${config.API_URL}/cargaSolicitudesAprobacion`, {
            params: { idEmpresa }
        })
            .then(res => {
                console.log(res.data);
                if (Array.isArray(res.data)) {
                    setListadoSolicitudesAprobacion(res.data);
                } else {
                    console.error('La respuesta no es un array:', res.data);
                    setListadoSolicitudesAprobacion([]);
                }
            })
            .catch(err => {
                console.error("Error al obtener las solicitudes de aprobación:", err);
            });
    };

    // Función para aprobar/rechazar solicitudes de aprobación
    const EstadoSolicitudAprobacion = async (estado, tipoSolicitud, id, observacion = '') => {
        // Validar firma antes de aprobar cualquier solicitud
        if (estado === 'Aprobado') {
            const firmaGuardada = localStorage.getItem('firmaAdministrador');
            if (!firmaGuardada) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Firma requerida',
                    text: 'Debe configurar su firma digital antes de aprobar solicitudes.',
                    confirmButtonColor: '#3085d6',
                });
                setMostrarFirmaDigital(true);
                return;
            }
        }

        const datos = {
            Estado: estado,
            Aprueba: cookies.usuario,
            id: id,
            Observacion: observacion
        };

        try {
            const response = await Axios.put(`${config.API_URL}/EstadoSolicitudAprobacion`, datos, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Administracion',
                Detalle: `Cambio estado solicitud ${tipoSolicitud} - Estado: ${estado}`,
                Estado: 'Éxito',
            });

            // Si se aprobó una orden de compra, descargar PDF automáticamente
            if (estado === 'Aprobado' && tipoSolicitud === 'Aprobacion_Orden_Compra') {
                const solicitud = listadoSolicitudesAprobacion.find(s => s.ID_Solicitud === id);
                if (solicitud && solicitud.ID_Referencia) {
                    await descargarPDFOrdenAprobada(solicitud.ID_Referencia);
                }
            }

            // Mensaje especial según tipo de solicitud
            let mensajeExito = `La solicitud se ${estado === 'Aprobado' ? 'aprobó' : 'rechazó'} exitosamente`;
            if (estado === 'Aprobado' && tipoSolicitud === 'Eliminacion_Vacaciones') {
                mensajeExito = 'La vacación ha sido eliminada exitosamente';
            } else if (estado === 'Aprobado' && tipoSolicitud === 'Eliminacion_Archivo_Trabajador') {
                mensajeExito = 'El archivo ha sido eliminado exitosamente';
            } else if (estado === 'Aprobado' && tipoSolicitud === 'Aprobacion_Orden_Compra') {
                mensajeExito += '. PDF descargado automáticamente.';
            }

            Swal.fire(
                '¡Éxito!',
                mensajeExito,
                'success'
            );

            getSolicitudesAprobacion();
        } catch (error) {
            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Administracion',
                Detalle: `Error al cambiar estado solicitud ${tipoSolicitud} - Error: ${error.message || error}`,
                Estado: 'Fallo',
            });

            Swal.fire(
                '¡Algo pasó!',
                'Hubo un error al procesar la solicitud.',
                'error'
            );
        }
    };

    // Función para inspeccionar detalles de orden de compra
    const inspeccionarOrden = async (idReferencia, tipoSolicitud) => {
        if (tipoSolicitud !== 'Aprobacion_Orden_Compra' || !idReferencia) {
            Swal.fire(
                'No disponible',
                'Esta función solo está disponible para solicitudes de órdenes de compra',
                'info'
            );
            return;
        }

        try {
            const response = await Axios.get(`${config.API_URL}/orden-compra-detalle/${idReferencia}`);

            if (response.data.success) {
                setOrdenDetalles(response.data);
                setModalVisible(true);
            } else {
                Swal.fire(
                    'Error',
                    'No se pudieron obtener los detalles de la orden',
                    'error'
                );
            }
        } catch (error) {
            console.error('Error al obtener detalles:', error);
            Swal.fire(
                'Error',
                'No se pudieron cargar los detalles de la orden',
                'error'
            );
        }
    };

    // Función para descargar PDF de orden aprobada
    const descargarPDFOrdenAprobada = async (idOrden) => {
        try {
            const response = await Axios.get(`${config.API_URL}/orden-compra-detalle/${idOrden}`);

            if (response.data.success) {
                const { orden, detalles } = response.data;

                // Generar PDF
                generarOrdenCompraPDF({
                    numeroOrden: orden.Numero_Orden,
                    fechaOrden: orden.Fecha_Orden,
                    senores: orden.Senores,
                    rutProveedor: orden.RUT_Proveedor,
                    comuna: orden.Comuna,
                    ciudad: orden.Ciudad,
                    direccion: orden.Direccion,
                    telefono: orden.Telefono,
                    emisorNombre: orden.Emisor_Nombre,
                    emisorRut: orden.Emisor_RUT,
                    usuarioCreador: orden.Usuario_Crea, // Usuario que creó la orden
                    usuarioAprueba: cookies.usuario, // Usuario que acaba de aprobar la orden
                    prioridad: orden.Prioridad,
                    tipoTrabajo: orden.Tipo_Trabajo,
                    detalles: detalles,
                    subtotal: orden.Subtotal,
                    iva: orden.IVA,
                    total: orden.Total,
                    empresa: getEmpresaName(cookies.selectedCard),
                    selectedCard: cookies.selectedCard,
                    observaciones: orden.Observaciones
                });

                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'Administracion',
                    Detalle: `PDF descargado automáticamente al aprobar Orden N° ${orden.Numero_Orden}`,
                    Estado: 'Éxito',
                });
            }
        } catch (error) {
            console.error('Error al descargar PDF:', error);
        }
    };

    // Función para manejar cuando se guarda la firma
    const handleFirmaGuardada = (firmaBase64) => {
        console.log('Firma guardada en Administracion:', firmaBase64);
        setMostrarFirmaDigital(false);
    };

    // Funciones de ordenamiento
    const sortData = (data, field, direction) => {
        return [...data].sort((a, b) => {
            let aValue = a[field];
            let bValue = b[field];

            // Manejar fechas
            if (field.includes('Fecha')) {
                aValue = new Date(aValue);
                bValue = new Date(bValue);
            }

            // Manejar números
            if (field === 'ID_Solicitud' || field === 'Dias_Solicitados') {
                aValue = Number(aValue);
                bValue = Number(bValue);
            }

            if (direction === 'asc') {
                return aValue > bValue ? 1 : -1;
            } else {
                return aValue < bValue ? 1 : -1;
            }
        });
    };

    // Función para obtener historial de vacaciones
    const getHistorialVacaciones = () => {
        if (!idEmpresa) {
            Swal.fire('Error', 'No se pudo identificar la empresa', 'error');
            return;
        }

        Axios.get(`${config.API_URL}/cargaVacaciones`, {
            params: {
                idEmpresa: idEmpresa
            }
        }).then((response) => {
            const historialFiltrado = response.data.filter(solicitud =>
                solicitud.Estado === 'Aprobado' || solicitud.Estado === 'Rechazado'
            );
            setHistorialVacaciones(historialFiltrado);
            setFilteredHistorialVacaciones(sortData(historialFiltrado, sortFieldVacaciones, sortDirectionVacaciones));
            setCurrentPageVacaciones(1);
        }).catch((error) => {
            console.log(error);
            Swal.fire('Error', 'No se pudo cargar el historial de vacaciones', 'error');
        });
    };

    // Función para obtener historial de órdenes de compra
    const getHistorialOrdenes = () => {
        if (!idEmpresa) {
            Swal.fire('Error', 'No se pudo identificar la empresa', 'error');
            return;
        }

        Axios.get(`${config.API_URL}/cargaSolicitudesAprobacion`, {
            params: {
                idEmpresa: idEmpresa,
                incluirHistorial: true
            }
        }).then((response) => {
            const historialFiltrado = response.data.filter(solicitud =>
                solicitud.Estado === 'Aprobado' || solicitud.Estado === 'Rechazado'
            );
            setHistorialOrdenes(historialFiltrado);
            setFilteredHistorialOrdenes(sortData(historialFiltrado, sortFieldOrdenes, sortDirectionOrdenes));
            setCurrentPageOrdenes(1);
        }).catch((error) => {
            console.log(error);
            Swal.fire('Error', 'No se pudo cargar el historial de órdenes', 'error');
        });
    };

    // Funciones para manejar ordenamiento de vacaciones
    const handleSortVacaciones = (field) => {
        const newDirection = sortFieldVacaciones === field && sortDirectionVacaciones === 'asc' ? 'desc' : 'asc';
        setSortFieldVacaciones(field);
        setSortDirectionVacaciones(newDirection);
        setFilteredHistorialVacaciones(sortData(filteredHistorialVacaciones, field, newDirection));
        setCurrentPageVacaciones(1);
    };

    // Funciones para manejar ordenamiento de órdenes
    const handleSortOrdenes = (field) => {
        const newDirection = sortFieldOrdenes === field && sortDirectionOrdenes === 'asc' ? 'desc' : 'asc';
        setSortFieldOrdenes(field);
        setSortDirectionOrdenes(newDirection);
        setFilteredHistorialOrdenes(sortData(filteredHistorialOrdenes, field, newDirection));
        setCurrentPageOrdenes(1);
    };

    // Funciones de paginación para vacaciones
    const getPaginatedVacaciones = () => {
        const startIndex = (currentPageVacaciones - 1) * itemsPerPageVacaciones;
        const endIndex = startIndex + itemsPerPageVacaciones;
        return filteredHistorialVacaciones.slice(startIndex, endIndex);
    };

    const getTotalPagesVacaciones = () => {
        return Math.ceil(filteredHistorialVacaciones.length / itemsPerPageVacaciones);
    };

    // Funciones de paginación para órdenes
    const getPaginatedOrdenes = () => {
        const startIndex = (currentPageOrdenes - 1) * itemsPerPageOrdenes;
        const endIndex = startIndex + itemsPerPageOrdenes;
        return filteredHistorialOrdenes.slice(startIndex, endIndex);
    };

    const getTotalPagesOrdenes = () => {
        return Math.ceil(filteredHistorialOrdenes.length / itemsPerPageOrdenes);
    };

    // Componente para encabezados ordenables
    const SortableHeader = ({ field, currentSortField, sortDirection, onSort, children }) => {
        const isActive = currentSortField === field;
        return (
            <th
                onClick={() => onSort(field)}
                style={{ cursor: 'pointer', userSelect: 'none' }}
                className={isActive ? 'bg-primary text-white' : ''}
            >
                <div className="d-flex justify-content-between align-items-center">
                    <span>{children}</span>
                    <div className="ml-1">
                        {isActive ? (
                            <i className={`fas fa-sort-${sortDirection === 'asc' ? 'up' : 'down'}`}></i>
                        ) : (
                            <i className="fas fa-sort text-muted"></i>
                        )}
                    </div>
                </div>
            </th>
        );
    };

    // Componente de paginación
    const PaginationControls = ({ currentPage, totalPages, onPageChange, itemsPerPage, onItemsPerPageChange }) => {
        const renderPageNumbers = () => {
            const pages = [];
            const maxPagesToShow = 5;
            let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
            let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

            if (endPage - startPage < maxPagesToShow - 1) {
                startPage = Math.max(1, endPage - maxPagesToShow + 1);
            }

            for (let i = startPage; i <= endPage; i++) {
                pages.push(
                    <button
                        key={i}
                        className={`btn btn-sm mx-1 ${currentPage === i ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => onPageChange(i)}
                    >
                        {i}
                    </button>
                );
            }
            return pages;
        };

        return (
            <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="d-flex align-items-center">
                    <span className="mr-2">Mostrar:</span>
                    <select
                        className="form-control form-control-sm"
                        style={{ width: 'auto' }}
                        value={itemsPerPage}
                        onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
                    >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                    </select>
                    <span className="ml-2">por página</span>
                </div>

                <div className="d-flex align-items-center">
                    <button
                        className="btn btn-outline-primary btn-sm mr-2"
                        onClick={() => onPageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        <i className="fas fa-chevron-left"></i> Anterior
                    </button>

                    {renderPageNumbers()}

                    <button
                        className="btn btn-outline-primary btn-sm ml-2"
                        onClick={() => onPageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Siguiente <i className="fas fa-chevron-right"></i>
                    </button>
                </div>

                <div>
                    <small className="text-muted">
                        Página {currentPage} de {totalPages}
                    </small>
                </div>
            </div>
        );
    };

    useEffect(() => {
        getSolicitudesVacaciones();
        getSolicitudesAprobacion();

        // Mostrar automáticamente la configuración de firma si no hay una guardada
        const firmaGuardada = localStorage.getItem('firmaAdministrador');
        if (!firmaGuardada) {
            setMostrarFirmaDigital(true);
        }
    }, [idEmpresa]);

    // Effect para actualizar los datos filtrados cuando cambian los datos originales
    useEffect(() => {
        if (historialVacaciones.length > 0) {
            setFilteredHistorialVacaciones(sortData(historialVacaciones, sortFieldVacaciones, sortDirectionVacaciones));
        }
    }, [historialVacaciones, sortFieldVacaciones, sortDirectionVacaciones]);

    useEffect(() => {
        if (historialOrdenes.length > 0) {
            setFilteredHistorialOrdenes(sortData(historialOrdenes, sortFieldOrdenes, sortDirectionOrdenes));
        }
    }, [historialOrdenes, sortFieldOrdenes, sortDirectionOrdenes]);

    return (
        <body id="page-top">
            <div id="wrapper">
                <Sidebar
                    imageUrl={imageUrl}
                    isComponentsCollapsed={isComponentsCollapsed}
                    toggleCollapse={toggleCollapse}
                    setIsComponentsCollapsed={setIsComponentsCollapsed}
                    isUtilitiesCollapsed={isUtilitiesCollapsed}
                    setIsUtilitiesCollapsed={setIsUtilitiesCollapsed}
                    isInventario={isInventario}
                    setisIventatioCollapsed={setisIventatioCollapsed}
                    isPrevencion={isPrevencion}
                    setisPrevencionCollapsed={setisPrevencionCollapsed}
                    isLogistica={isLogistica}
                    setisLogisticaCollapsed={setisLogisticaCollapsed}
                    isContabilidadCollapsed={isContabilidadCollapsed}
                    setIsContabilidadCollapsed={setIsContabilidadCollapsed}
                    isAdministracionCollapsed={isAdministracionCollapsed}
                    setIsAdministracionCollapsed={setIsAdministracionCollapsed}
                    cookies={cookies}
                />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <div className="container-fluid">
                            {/* Configuración de Firma Digital */}
                            <div className="row mb-4">
                                <div className="col-lg-12">
                                    <div className="card shadow">
                                        <div className="card-header py-3 d-flex justify-content-between align-items-center">
                                            <div>
                                                <h6 className="m-0 font-weight-bold text-primary">Configuración de Firma Digital</h6>
                                                <small className="text-muted">
                                                    {localStorage.getItem('firmaAdministrador') ?
                                                        '✅ Firma configurada' :
                                                        '❌ Sin firma configurada - Requerida para aprobar órdenes'
                                                    }
                                                </small>
                                            </div>
                                            <button
                                                className={`btn btn-sm ${localStorage.getItem('firmaAdministrador') ? 'btn-outline-primary' : 'btn-warning'}`}
                                                onClick={() => setMostrarFirmaDigital(!mostrarFirmaDigital)}
                                            >
                                                {mostrarFirmaDigital ? 'Ocultar' : 'Configurar Firma'}
                                            </button>
                                        </div>
                                        {mostrarFirmaDigital && (
                                            <div className="card-body">
                                                <FirmaDigital
                                                    onFirmaGuardada={handleFirmaGuardada}
                                                    firmaExistente={localStorage.getItem('firmaAdministrador')}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Tabla de solicitudes de vacaciones */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card shadow mb-4">
                                        <div className="card-header py-3 d-flex justify-content-between align-items-center">
                                            <div>
                                                <h6 className="m-0 font-weight-bold text-primary">Listado de solicitudes pendientes de vacaciones</h6>
                                                <small className="text-muted">Empresa: {empresa}</small>
                                            </div>
                                            <button
                                                className="btn btn-outline-info btn-sm"
                                                onClick={() => {
                                                    getHistorialVacaciones();
                                                    setModalHistorialVacaciones(true);
                                                }}
                                                title="Ver historial de vacaciones"
                                            >
                                                <i className="fas fa-umbrella-beach"></i> Historial
                                            </button>
                                        </div>
                                        <div className="card-body">
                                            <div className="input-group mb-3">
                                                <div className="col-md-12">
                                                    <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                        <thead>
                                                            <tr>
                                                                <th>ID</th>
                                                                <th>Fecha solicitud</th>
                                                                <th>Solicitante</th>
                                                                <th>Trabajador</th>
                                                                <th>Dias solicitados</th>
                                                                <th>Periodo</th>
                                                                <th>Observacion</th>
                                                                <th>Acciones</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                Array.isArray(listadoVacaciones) && listadoVacaciones.length > 0 ? (
                                                                    listadoVacaciones.map((val, key) => (
                                                                        <tr key={key}>
                                                                            <th scope="row">{val.ID_Solicitud}</th>
                                                                            <td>{moment(val.Fecha_Solicitud).format('DD/MM/YYYY')}</td>
                                                                            <td>{val.Solicitante}</td>
                                                                            <td>{val.Nombre_Completo}</td>
                                                                            <td>{val.Dias_Solicitados}</td>
                                                                            <td>{moment(val.Fecha_Inicio).format('DD/MM/YYYY')} al {moment(val.Fecha_Fin).format('DD/MM/YYYY')}</td>
                                                                            <td>{val.Observacion}</td>
                                                                            <td data-label="Acciones">
                                                                                <div className="btn-group" role="group" aria-label="Basic example">
                                                                                    <button type="button" className="btn btn-info" onClick={() => EstadoVacaciones("Aprobado", val.Nombre_Completo, val.ID_Solicitud)}>Aprobar</button>
                                                                                    <button type="button" className="btn btn-danger" onClick={() => EstadoVacaciones("Rechazado", val.Nombre_Completo, val.ID_Solicitud)}>Rechazar</button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr><td colSpan="8">No hay información de solicitudes pendientes.</td></tr>
                                                                )
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Nueva tabla para solicitudes de aprobación */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card shadow mb-4">
                                        <div className="card-header py-3 d-flex justify-content-between align-items-center">
                                            <div>
                                                <h6 className="m-0 font-weight-bold text-primary">Solicitudes pendientes de aprobación</h6>
                                                <small className="text-muted">Empresa: {empresa}</small>
                                            </div>
                                            <button
                                                className="btn btn-outline-success btn-sm"
                                                onClick={() => {
                                                    getHistorialOrdenes();
                                                    setModalHistorialOrdenes(true);
                                                }}
                                                title="Ver historial de órdenes de compra"
                                            >
                                                <i className="fas fa-file-invoice"></i> Historial
                                            </button>
                                        </div>
                                        <div className="card-body">
                                            <div className="input-group mb-3">
                                                <div className="col-md-12">
                                                    <table className="table table-bordered" id="dataTableAprobacion" width="100%" cellSpacing="0">
                                                        <thead>
                                                            <tr>
                                                                <th>ID</th>
                                                                <th>Fecha solicitud</th>
                                                                <th>Módulo</th>
                                                                <th>Tipo solicitud</th>
                                                                <th>Usuario crea</th>
                                                                <th>Observación</th>
                                                                <th>Acciones</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                Array.isArray(listadoSolicitudesAprobacion) && listadoSolicitudesAprobacion.length > 0 ? (
                                                                    listadoSolicitudesAprobacion.map((val, key) => (
                                                                        <tr key={key}>
                                                                            <th scope="row">{val.ID_Solicitud}</th>
                                                                            <td>{moment(val.Fecha_Solicitud).format('DD/MM/YYYY HH:mm')}</td>
                                                                            <td>{val.Modulo}</td>
                                                                            <td>{val.Tipo_Solicitud.replace(/_/g, ' ')}</td>
                                                                            <td>{val.Usuario_Crea}</td>
                                                                            <td>{val.Observacion}</td>
                                                                            <td data-label="Acciones">
                                                                                <div className="btn-group" role="group" aria-label="Basic example">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-info btn-sm"
                                                                                        onClick={() => EstadoSolicitudAprobacion("Aprobado", val.Tipo_Solicitud, val.ID_Solicitud)}
                                                                                    >
                                                                                        Aprobar
                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-danger btn-sm"
                                                                                        onClick={() => EstadoSolicitudAprobacion("Rechazado", val.Tipo_Solicitud, val.ID_Solicitud)}
                                                                                    >
                                                                                        Rechazar
                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-warning btn-sm"
                                                                                        onClick={() => inspeccionarOrden(val.ID_Referencia, val.Tipo_Solicitud)}
                                                                                        title="Inspeccionar detalles"
                                                                                    >
                                                                                        <i className="fas fa-eye"></i>
                                                                                    </button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr><td colSpan="7">No hay solicitudes de aprobación pendientes.</td></tr>
                                                                )
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal para inspeccionar orden de compra */}
            {modalVisible && ordenDetalles && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1050 }} onClick={() => setModalVisible(false)}>
                    <div className="modal-dialog modal-xl" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header bg-light border-bottom" style={{ position: 'relative' }}>
                                <h4 className="modal-title">
                                    <i className="fas fa-file-invoice"></i> Inspeccionar Orden de Compra N° {ordenDetalles.orden.Numero_Orden}
                                </h4>
                                <button
                                    type="button"
                                    className="btn btn-sm rounded-circle p-1"
                                    onClick={() => setModalVisible(false)}
                                    style={{
                                        position: 'absolute',
                                        top: '10px',
                                        right: '15px',
                                        width: '32px',
                                        height: '32px',
                                        border: '1px solid #dee2e6',
                                        backgroundColor: '#f8f9fa',
                                        color: '#6c757d',
                                        transition: 'all 0.3s ease',
                                        zIndex: 1
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#dc3545';
                                        e.target.style.color = 'white';
                                        e.target.style.borderColor = '#dc3545';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#6c757d';
                                        e.target.style.borderColor = '#dee2e6';
                                    }}
                                    title="Cerrar"
                                >
                                    <i className="fas fa-times"></i>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h5 className="text-primary">Información del Proveedor</h5>
                                        <p><strong>Señores:</strong> {ordenDetalles.orden.Senores}</p>
                                        <p><strong>RUT:</strong> {ordenDetalles.orden.RUT_Proveedor}</p>
                                        <p><strong>Dirección:</strong> {ordenDetalles.orden.Direccion}</p>
                                        <p><strong>Comuna:</strong> {ordenDetalles.orden.Comuna}</p>
                                        <p><strong>Ciudad:</strong> {ordenDetalles.orden.Ciudad}</p>
                                        <p><strong>Teléfono:</strong> {ordenDetalles.orden.Telefono}</p>
                                    </div>
                                    <div className="col-md-6">
                                        <h5 className="text-primary">Información de la Orden</h5>
                                        <p><strong>Fecha:</strong> {moment(ordenDetalles.orden.Fecha_Orden).format('DD/MM/YYYY')}</p>
                                        <p><strong>Emisor:</strong> {ordenDetalles.orden.Emisor_Nombre}</p>
                                        <p><strong>RUT Emisor:</strong> {ordenDetalles.orden.Emisor_RUT}</p>
                                        <p><strong>Prioridad:</strong> {ordenDetalles.orden.Prioridad}</p>
                                        <p><strong>Tipo Trabajo:</strong> {ordenDetalles.orden.Tipo_Trabajo}</p>
                                        <p><strong>Estado:</strong>
                                            <span className={`badge badge-${ordenDetalles.orden.Estado === 'Pendiente' ? 'warning' :
                                                ordenDetalles.orden.Estado === 'Aprobada' ? 'success' :
                                                    ordenDetalles.orden.Estado === 'Rechazada' ? 'danger' : 'primary'}`}>
                                                {ordenDetalles.orden.Estado}
                                            </span>
                                        </p>
                                    </div>
                                </div>

                                <hr />

                                <h5 className="text-primary">Detalles de la Orden</h5>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-sm">
                                        <thead className="thead-dark">
                                            <tr>
                                                <th>Item</th>
                                                <th>Descripción</th>
                                                <th>Valor Unitario</th>
                                                <th>Cantidad</th>
                                                <th>Valor Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ordenDetalles.detalles.map((detalle, index) => (
                                                <tr key={index}>
                                                    <td>{detalle.Item}</td>
                                                    <td>{detalle.Descripcion}</td>
                                                    <td>${detalle.Valor_Unitario.toLocaleString()}</td>
                                                    <td>{detalle.Cantidad}</td>
                                                    <td>${detalle.Valor_Total.toLocaleString()}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-md-8">
                                        <h6 className="text-primary">Observaciones</h6>
                                        <p>{ordenDetalles.orden.Observaciones || 'Sin observaciones'}</p>
                                    </div>
                                    <div className="col-md-4">
                                        <table className="table table-sm">
                                            <tr>
                                                <td><strong>Subtotal:</strong></td>
                                                <td>${ordenDetalles.orden.Subtotal.toLocaleString()}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>IVA (19%):</strong></td>
                                                <td>${ordenDetalles.orden.IVA.toLocaleString()}</td>
                                            </tr>
                                            <tr className="table-primary">
                                                <td><strong>TOTAL:</strong></td>
                                                <td><strong>${ordenDetalles.orden.Total.toLocaleString()}</strong></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => descargarPDFOrdenAprobada(ordenDetalles.orden.ID_Orden)}
                                >
                                    <i className="fas fa-file-pdf"></i> Descargar PDF
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setModalVisible(false)}
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal para historial de vacaciones */}
            {modalHistorialVacaciones && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1050 }} onClick={() => setModalHistorialVacaciones(false)}>
                    <div className="modal-dialog modal-xl" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header bg-light border-bottom" style={{ position: 'relative' }}>
                                <h4 className="modal-title">
                                    <i className="fas fa-umbrella-beach text-info"></i> Historial de Solicitudes de Vacaciones
                                </h4>
                                <button
                                    type="button"
                                    className="btn btn-sm rounded-circle p-1"
                                    onClick={() => setModalHistorialVacaciones(false)}
                                    style={{
                                        position: 'absolute',
                                        top: '10px',
                                        right: '15px',
                                        width: '32px',
                                        height: '32px',
                                        border: '1px solid #dee2e6',
                                        backgroundColor: '#f8f9fa',
                                        color: '#6c757d',
                                        transition: 'all 0.3s ease',
                                        zIndex: 1
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#dc3545';
                                        e.target.style.color = 'white';
                                        e.target.style.borderColor = '#dc3545';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#6c757d';
                                        e.target.style.borderColor = '#dee2e6';
                                    }}
                                    title="Cerrar"
                                >
                                    <i className="fas fa-times"></i>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="table-responsive" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                                    <table className="table table-bordered table-striped table-hover">
                                        <thead className="thead-dark" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                            <tr>
                                                <SortableHeader
                                                    field="ID_Solicitud"
                                                    currentSortField={sortFieldVacaciones}
                                                    sortDirection={sortDirectionVacaciones}
                                                    onSort={handleSortVacaciones}
                                                >
                                                    ID
                                                </SortableHeader>
                                                <SortableHeader
                                                    field="Fecha_Solicitud"
                                                    currentSortField={sortFieldVacaciones}
                                                    sortDirection={sortDirectionVacaciones}
                                                    onSort={handleSortVacaciones}
                                                >
                                                    Fecha Solicitud
                                                </SortableHeader>
                                                <SortableHeader
                                                    field="Solicitante"
                                                    currentSortField={sortFieldVacaciones}
                                                    sortDirection={sortDirectionVacaciones}
                                                    onSort={handleSortVacaciones}
                                                >
                                                    Solicitante
                                                </SortableHeader>
                                                <SortableHeader
                                                    field="Nombre_Completo"
                                                    currentSortField={sortFieldVacaciones}
                                                    sortDirection={sortDirectionVacaciones}
                                                    onSort={handleSortVacaciones}
                                                >
                                                    Trabajador
                                                </SortableHeader>
                                                <SortableHeader
                                                    field="Dias_Solicitados"
                                                    currentSortField={sortFieldVacaciones}
                                                    sortDirection={sortDirectionVacaciones}
                                                    onSort={handleSortVacaciones}
                                                >
                                                    Días
                                                </SortableHeader>
                                                <th>Período</th>
                                                <SortableHeader
                                                    field="Estado"
                                                    currentSortField={sortFieldVacaciones}
                                                    sortDirection={sortDirectionVacaciones}
                                                    onSort={handleSortVacaciones}
                                                >
                                                    Estado
                                                </SortableHeader>
                                                <SortableHeader
                                                    field="Fecha_Aprobacion"
                                                    currentSortField={sortFieldVacaciones}
                                                    sortDirection={sortDirectionVacaciones}
                                                    onSort={handleSortVacaciones}
                                                >
                                                    Fecha Aprobación
                                                </SortableHeader>
                                                <SortableHeader
                                                    field="Aprueba"
                                                    currentSortField={sortFieldVacaciones}
                                                    sortDirection={sortDirectionVacaciones}
                                                    onSort={handleSortVacaciones}
                                                >
                                                    Aprobado Por
                                                </SortableHeader>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {getPaginatedVacaciones().length > 0 ? (
                                                getPaginatedVacaciones().map((solicitud, index) => (
                                                    <tr key={index}>
                                                        <td>{solicitud.ID_Solicitud}</td>
                                                        <td>{moment(solicitud.Fecha_Solicitud).format('DD/MM/YYYY')}</td>
                                                        <td>{solicitud.Solicitante}</td>
                                                        <td>{solicitud.Nombre_Completo}</td>
                                                        <td>{solicitud.Dias_Solicitados}</td>
                                                        <td>{moment(solicitud.Fecha_Inicio).format('DD/MM/YYYY')} al {moment(solicitud.Fecha_Fin).format('DD/MM/YYYY')}</td>
                                                        <td>
                                                            <span className={`badge badge-${solicitud.Estado === 'Aprobado' ? 'success' : 'danger'}`}>
                                                                {solicitud.Estado}
                                                            </span>
                                                        </td>
                                                        <td>{solicitud.Fecha_Aprobacion ? moment(solicitud.Fecha_Aprobacion).format('DD/MM/YYYY HH:mm') : 'N/A'}</td>
                                                        <td>{solicitud.Aprueba || 'N/A'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr><td colSpan="9" className="text-center">No hay historial de vacaciones disponible</td></tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <PaginationControls
                                    currentPage={currentPageVacaciones}
                                    totalPages={getTotalPagesVacaciones()}
                                    onPageChange={setCurrentPageVacaciones}
                                    itemsPerPage={itemsPerPageVacaciones}
                                    onItemsPerPageChange={(newItemsPerPage) => {
                                        setItemsPerPageVacaciones(newItemsPerPage);
                                        setCurrentPageVacaciones(1);
                                    }}
                                />
                            </div>
                            <div className="modal-footer bg-light border-top">
                                <button type="button" className="btn btn-secondary" onClick={() => setModalHistorialVacaciones(false)}>
                                    <i className="fas fa-times mr-1"></i> Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal para historial de órdenes de compra */}
            {modalHistorialOrdenes && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1050 }} onClick={() => setModalHistorialOrdenes(false)}>
                    <div className="modal-dialog modal-xl" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header bg-light border-bottom" style={{ position: 'relative' }}>
                                <h4 className="modal-title">
                                    <i className="fas fa-file-invoice text-success"></i> Historial de Solicitudes de Órdenes de Compra
                                </h4>
                                <button
                                    type="button"
                                    className="btn btn-sm rounded-circle p-1"
                                    onClick={() => setModalHistorialOrdenes(false)}
                                    style={{
                                        position: 'absolute',
                                        top: '10px',
                                        right: '15px',
                                        width: '32px',
                                        height: '32px',
                                        border: '1px solid #dee2e6',
                                        backgroundColor: '#f8f9fa',
                                        color: '#6c757d',
                                        transition: 'all 0.3s ease',
                                        zIndex: 1
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#dc3545';
                                        e.target.style.color = 'white';
                                        e.target.style.borderColor = '#dc3545';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#6c757d';
                                        e.target.style.borderColor = '#dee2e6';
                                    }}
                                    title="Cerrar"
                                >
                                    <i className="fas fa-times"></i>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="table-responsive" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                                    <table className="table table-bordered table-striped table-hover">
                                        <thead className="thead-dark" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                            <tr>
                                                <SortableHeader
                                                    field="ID_Solicitud"
                                                    currentSortField={sortFieldOrdenes}
                                                    sortDirection={sortDirectionOrdenes}
                                                    onSort={handleSortOrdenes}
                                                >
                                                    ID
                                                </SortableHeader>
                                                <SortableHeader
                                                    field="Fecha_Solicitud"
                                                    currentSortField={sortFieldOrdenes}
                                                    sortDirection={sortDirectionOrdenes}
                                                    onSort={handleSortOrdenes}
                                                >
                                                    Fecha Solicitud
                                                </SortableHeader>
                                                <SortableHeader
                                                    field="Modulo"
                                                    currentSortField={sortFieldOrdenes}
                                                    sortDirection={sortDirectionOrdenes}
                                                    onSort={handleSortOrdenes}
                                                >
                                                    Módulo
                                                </SortableHeader>
                                                <SortableHeader
                                                    field="Tipo_Solicitud"
                                                    currentSortField={sortFieldOrdenes}
                                                    sortDirection={sortDirectionOrdenes}
                                                    onSort={handleSortOrdenes}
                                                >
                                                    Tipo Solicitud
                                                </SortableHeader>
                                                <SortableHeader
                                                    field="Usuario_Crea"
                                                    currentSortField={sortFieldOrdenes}
                                                    sortDirection={sortDirectionOrdenes}
                                                    onSort={handleSortOrdenes}
                                                >
                                                    Usuario
                                                </SortableHeader>
                                                <SortableHeader
                                                    field="Estado"
                                                    currentSortField={sortFieldOrdenes}
                                                    sortDirection={sortDirectionOrdenes}
                                                    onSort={handleSortOrdenes}
                                                >
                                                    Estado
                                                </SortableHeader>
                                                <SortableHeader
                                                    field="Fecha_Aprobacion"
                                                    currentSortField={sortFieldOrdenes}
                                                    sortDirection={sortDirectionOrdenes}
                                                    onSort={handleSortOrdenes}
                                                >
                                                    Fecha Aprobación
                                                </SortableHeader>
                                                <SortableHeader
                                                    field="Aprueba"
                                                    currentSortField={sortFieldOrdenes}
                                                    sortDirection={sortDirectionOrdenes}
                                                    onSort={handleSortOrdenes}
                                                >
                                                    Aprobado Por
                                                </SortableHeader>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {getPaginatedOrdenes().length > 0 ? (
                                                getPaginatedOrdenes().map((solicitud, index) => (
                                                    <tr key={index}>
                                                        <td>{solicitud.ID_Solicitud}</td>
                                                        <td>{moment(solicitud.Fecha_Solicitud).format('DD/MM/YYYY HH:mm')}</td>
                                                        <td>{solicitud.Modulo}</td>
                                                        <td>{solicitud.Tipo_Solicitud.replace(/_/g, ' ')}</td>
                                                        <td>{solicitud.Usuario_Crea}</td>
                                                        <td>
                                                            <span className={`badge badge-${solicitud.Estado === 'Aprobado' ? 'success' : 'danger'}`}>
                                                                {solicitud.Estado}
                                                            </span>
                                                        </td>
                                                        <td>{solicitud.Fecha_Aprobacion ? moment(solicitud.Fecha_Aprobacion).format('DD/MM/YYYY HH:mm') : 'N/A'}</td>
                                                        <td>{solicitud.Aprueba || 'N/A'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr><td colSpan="8" className="text-center">No hay historial de órdenes disponible</td></tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <PaginationControls
                                    currentPage={currentPageOrdenes}
                                    totalPages={getTotalPagesOrdenes()}
                                    onPageChange={setCurrentPageOrdenes}
                                    itemsPerPage={itemsPerPageOrdenes}
                                    onItemsPerPageChange={(newItemsPerPage) => {
                                        setItemsPerPageOrdenes(newItemsPerPage);
                                        setCurrentPageOrdenes(1);
                                    }}
                                />
                            </div>
                            <div className="modal-footer bg-light border-top">
                                <button type="button" className="btn btn-secondary" onClick={() => setModalHistorialOrdenes(false)}>
                                    <i className="fas fa-times mr-1"></i> Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </body>
    )
}

export default Administracion